import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AuthService from "services/auth.service";

import { Row, Col, Input } from "reactstrap";

const ChangePassword = (props) => {
  const { id } = useParams();
  let navigate = useNavigate();

  const initialUserState = {
    id: null,
    // title: "",
    // description: "",
    // published: false,
    email: "",
    password: ""
  };

  const [currentUser, setCurrentUser] = useState(initialUserState);
  const [message, setMessage] = useState("");
  
  const [showPassword, setShowPassword] = useState(false);
  const [password, setNewPassword] = useState('');

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const getUser = (id) => {
    AuthService.get(id)
      .then((response) => {
        setCurrentUser(response.data);
        //console.log(response.data);
      })
      .catch((e) => {
       // console.log(e);
      });
  };

  useEffect(() => {
    if (id) getUser(id);
  }, [id]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCurrentUser({ ...currentUser, [name]: value });
  };

  const updateUserPassword = () => {   
   
    AuthService.updatePassword(currentUser.id,  {password} )
      .then(response => {
        //console.log(response.data);
        setMessage(response.data.message);
      })
      .catch(error => {
        console.error(error);
        setMessage('Error updating password.');
      });
  };

  return (
    <div className="content">
      <Row>
        <Col>
          {currentUser ? (
            <div className="edit-form">
              <h4>Password Change</h4>
              <h6>effect will take place on the below account</h6>
              <form>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="email"
                    value={currentUser.email}
                    onChange={handleInputChange}
                    disabled
                    //   validations={[required, validEmail]}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="password">Input new password</label>
                  <Input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    name="password"
                    value={password}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Enter new password"
                    required
                  />
                  <span
                    className="toggle-password"
                    onClick={handleTogglePassword}
                  >
                    {showPassword ? "👀" : "👁️"}
                  </span>
                </div>
              </form>

              <button
                type="submit"
                className="badge badge-success"
                onClick={updateUserPassword}
              >
                Update
              </button>
              <p>{message}</p>
            </div>
          ) : (
            <div>
              <br />
              <p>Please click on a Tutorial...</p>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ChangePassword;
